import {
  call,
  put
} from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import {
  getDatabases,
  getProjectInfos,
  getWorkbookInfos,
  replaceDatasourceIdWithConnectionIdForMixedContent
} from '../../app/sagas/spaces/SpacesSagaHelpers';
import { Messages } from '../../codegen/Localize';
import { getExplorableItemDefinition } from '../../contentDefinitionInterfaces/ContentDefinitionsLists';
import { ExplorableItemType } from '../../ts/models/ContentType';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { Set } from '../../ts/models/Set';
import { ExploreContentApi_ContentType } from '../../ts/ServerApi/types/IContent';
import { SetContentPermissionsAction } from '../actions/SetContentPermissionsActions';
import { EditPermissionsAction } from '../services/EditPermissionsAction';

export function openPermissionsDialog(content: IContentInfo[], contentType: ExploreContentApi_ContentType): Promise<any> {
  return EditPermissionsAction.showEditPermissionsDialog(Set.fromIdItemArray(content), contentType);
}

export function* setContentPermissions(action: SetContentPermissionsAction) {
  try {
    if(action.content.length < 1){
      throw new Error('setContentPermissions was called without any content');
    }

    const contentType = getExplorableItemDefinition(action.content[0].contentType as ExplorableItemType);
    let content = action.content;
    if (contentType.itemType === 'datasource') {
      content = yield call(replaceDatasourceIdWithConnectionIdForMixedContent, content);
    }

    // TFS 815536: Re-fetching the projects is necessary to avoid stale lock statuses being shown
    // in the permissions dialog. If we implement lock status via source authorizables
    // (TFS 667457), we can remove this re-fetch.
    if (contentType.itemType === 'project') {
      content = yield getProjectInfos(action.content);
    }

    // get sheets as tabs status
    if (contentType.itemType === 'workbook') {
      content = yield getWorkbookInfos(action.content);
    }

    // Make a graphql call to get locked status of databases
    if (contentType.itemType === 'database' || contentType.itemType === 'databaseWithCrass') {
      const idToDatabasesMap: {[id: string]: boolean} = { };

      const databases = yield getDatabases(action.content);

      for (const database of databases) {
        idToDatabasesMap[database.id] = database.controlledPermissionsEnabled;
      }

      content = content.map(contentElement => { return {
          ...contentElement,
          controlledPermissionsEnabled: idToDatabasesMap[contentElement.id]
          };
        });
    }

    // Hack to use `vizportalId` field for Database & Table
    // TFS912863: Remove this hack once we switched to use vizportalId as primary ID for database & table
    if (contentType.itemType === 'table' ||
        contentType.itemType === 'tableWithCrass' ||
        contentType.itemType === 'database' ||
        contentType.itemType === 'databaseWithCrass') {
      content = content.map(contentElement => {return {...contentElement, id: String(contentElement.vizportalId)};});
    }

    const itemType = contentType.itemType === 'tableWithCrass' ? 'table' : contentType.itemType === 'databaseWithCrass' ? 'database' : contentType.itemType;

    yield call(openPermissionsDialog, content, itemType);
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
